import loadable from "@loadable/component";
import CreateIcon from "../../Icons/Create";
import usePostHook from "../../customHooks/usePostHook";
import APIS from "../../constant/EndPoint";

const CreateStateComponent = loadable(
  () => import("../../components/State/CreateState")
);
const CreateState = () => {
  const { mutateAsync, isPostLoading  } = usePostHook({
    queryKey: ["state"],
    navigateURL: "/state",
  });

  const handleCreate = async (values: any, setError: any) => {
    const url = `${APIS.LOCATION}`;
    let formData = {
      ...values,
    };
    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <>
      <div className="w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center">
        <CreateIcon />
        <span className="text-[#5E5757] font-bold text-xl">Create State</span>
      </div>
      <CreateStateComponent
      isLoading={isPostLoading}
       handleCreate={handleCreate} 
       />
    </>
  );
};
export default CreateState;
